import probeTypes from '../../util/get-probe-types'
import RequestQueueInstance from '../../util/request-queue'

export class StepConnectedTcSetup {
  constructor (onboarding) {
    this.onboarding = onboarding;
  }

  id = "connected_tc_setup";
  title = "Select Your Probe Type";

  probe_enabled = false;
  last_reading = null;
  current_probe_type = null;

  AF_template = `
      
  <p class="onboarding-guide-instruction text-center tc-probe-status">
    Loading Clamp Status...
  </p>
  
  <div class="onboarding-guide-next">
    <button type="button" class="button button--medium onboarding-guide-next-btn" data-for="tc_probe_save">
      Continue
    </button>
  </div>
    
  `

  // Selective (fire-sprinkler) sensors always ship with a probe and only ever
  // use one of two functionally-identical K-type clamp probes: the standard
  // clamp or the velcro-strap variant. Show just those two, plus a live probe
  // reading on the same page so the user can confirm they plugged it in.
  selective_template = `

    <p class="onboarding-guide-instruction text-center">
      Select the probe that came with your sensor, then plug it into the sensor to confirm it's reading correctly.
    </p>

    <div class="onboarding-tc-type-image-select onboarding-tc-type-image-select--selective">

      <div class="onboarding-tc-type-select" data-for="CLAMP">

        <img src="${window.site.home}/../assets/images/setup/probe-clamp.jpg" width="309" height="387" />

        <h3>Probe Clamp</h3>

        <div class="onboarding-tc-type-select__button">
          <button type="button" data-action="select_probe_type" data-for="CLAMP" class="button button--medium">
            Select
          </button>
          <div class="onboarding-tc-type-select__selected hide">
            Selected <img src="${window.site.home}/../assets/images/icon-check-green.svg" width="10" height="10" />
          </div>
        </div>
      </div>

      <div class="onboarding-tc-type-select" data-for="VELCRO_STRAP">

        <img src="${window.site.home}/../assets/images/setup/probe-velcro-strap.png" width="309" height="387" />

        <h3>Velcro Strap Probe</h3>

        <div class="onboarding-tc-type-select__button">
          <button type="button" data-action="select_probe_type" data-for="VELCRO_STRAP" class="button button--medium">
            Select
          </button>
          <div class="onboarding-tc-type-select__selected hide">
            Selected <img src="${window.site.home}/../assets/images/icon-check-green.svg" width="10" height="10" />
          </div>
        </div>
      </div>

    </div>

    <div class="onboarding-tc-live-reading">
      <p class="onboarding-guide-instruction text-center tc-probe-status">
        Select your probe above to begin
      </p>
    </div>

    <div class="onboarding-tc-test-toggle" style="display:none;">
      <button type="button" class="button button--light-gray" data-for="tc_test_toggle_probe">
        Testing: Simulate Probe Plugged In
      </button>
    </div>

    <div class="onboarding-guide-next">
      <button type="button" class="button button--medium onboarding-guide-next-btn" data-for="tc_probe_save" disabled>
        Continue
      </button>
    </div>

  `

  template = `
  <div class="onboarding-step" data-for="connected_tc_setup">

    <p class="onboarding-guide-instruction text-center tc-probe-status">
      Loading Probe Status...
    </p>

    <div>
    
      <div class="onboarding-tc-type-image-select">
        <div class="onboarding-tc-type-select" data-for="T">
          
          <img src="${window.site.home}/../assets/images/setup/probe-t-type.jpg" width="309" height="387" />
          
          <h3>T-Type Probe</h3>
          
          <div class="onboarding-tc-type-select__button">
            <button type="button" data-action="select_probe_type" data-for="T" class="button button--medium">
              Select
            </button>
            <div class="onboarding-tc-type-select__selected hide">
              Selected <img src="${window.site.home}/../assets/images/icon-check-green.svg" width="10" height="10" />
            </div>
          </div>
        </div>
        <div class="onboarding-tc-type-select" data-for="K">
          
          <img src="${window.site.home}/../assets/images/setup/probe-k-type.jpg" width="309" height="387" />
          
          <h3>K-Type Probe</h3>
          
          <div class="onboarding-tc-type-select__button">
            <button type="button" data-action="select_probe_type" data-for="K" class="button button--medium">
              Select
            </button>
            <div class="onboarding-tc-type-select__selected hide">
              Selected <img src="${window.site.home}/../assets/images/icon-check-green.svg" width="10" height="10" />
            </div>
          </div>
        </div>
        <div class="onboarding-tc-type-select" data-for="BUFFER_BOTTLE">
          
          <img src="${window.site.home}/../assets/images/setup/probe-buffer-bottle.jpg" width="309" height="387" />
          
          <h3>Buffer Bottle</h3>
          
          <div class="onboarding-tc-type-select__button">
            <button type="button" data-action="select_probe_type" data-for="BUFFER_BOTTLE" class="button button--medium">
              Select
            </button>
            <div class="onboarding-tc-type-select__selected hide">
              Selected <img src="${window.site.home}/../assets/images/icon-check-green.svg" width="10" height="10" />
            </div>
          </div>
        </div>
        <div class="onboarding-tc-type-select" data-for="CLAMP">
          
          <img src="${window.site.home}/../assets/images/setup/probe-clamp.jpg" width="309" height="387" />
          
          <h3>Pipe Clamp</h3>
          
          <div class="onboarding-tc-type-select__button">
            <button type="button" data-action="select_probe_type" data-for="CLAMP" class="button button--medium">
              Select
            </button>
            <div class="onboarding-tc-type-select__selected hide">
              Selected <img src="${window.site.home}/../assets/images/icon-check-green.svg" width="10" height="10" />
            </div>
          </div>
        </div>
        <div class="onboarding-tc-type-select" data-for="WINE_BOTTLE">
          
          <img src="${window.site.home}/../assets/images/setup/probe-wine-bottle.jpg" width="309" height="387" />
          
          <h3>Wine Bottle</h3>
          
          <div class="onboarding-tc-type-select__button">
            <button type="button" data-action="select_probe_type" data-for="WINE_BOTTLE" class="button button--medium">
              Select
            </button>
            <div class="onboarding-tc-type-select__selected hide">
              Selected <img src="${window.site.home}/../assets/images/icon-check-green.svg" width="10" height="10" />
            </div>
          </div>
        </div>
      </div>
      
      <div class="onboarding-guide-next">
        <button type="button" class="button button--medium onboarding-guide-next-btn" data-for="tc_probe_save">
          Save Probe Settings
        </button>
      </div>
    
      <div class="divider divider--margin-md divider--thick"></div>
    
      <select class="onboarding-tc-type-different-select" name="tc_type">
        <option value="-">Other probe types...</option>
        ${probeTypes.map(value => {
          return `
          <option value="${value}">${value}-TYPE</option>
          `
        })}
        <option value="none">No Probe</option>
      </select>
    </div>
      
    <div class="onboarding-guide-help">
      <button class="button button--link onboarding-guide-help-btn" data-for="tc_no_probe">
        I'm not using a probe
      </button>
    </div>
      
  </div>
  `;

  onBack = () => {
    this.onboarding.goToStep(this.onboarding.stepBeforeProbeStep());
  }

  onActivate = () => {

    console.log(this.onboarding.sensor)

    this.onboarding.showBackButton();

    // Selective sensors get the dedicated 2-option probe experience.
    if(this.onboarding.isSelective()) {
      this.setupSelective();
      this.GetReadings();
      return;
    }

    let brand_key = this.onboarding.sensor.sid.substr(2, 2)

    console.log(brand_key)


    if(brand_key === 'AF') {

      this.branding = "AF";

      // the AF sensor ships with a pipe clamp, which is what its probe alert is
      // named after on the alerts review
      this.onboarding.probe_selection = 'CLAMP';

      // if AF sensor use AF template
      $(this.onboarding.container).find('.onboarding-step[data-for="connected_tc_setup"]').html(this.AF_template);
      $(this.onboarding.container).find('.onboarding-heading__title').html("Connect Your Pipe Clamp")

      this.$probeStatus = $(this.onboarding.container).find('.tc-probe-status');

      $(this.onboarding.container).find('.button[data-for="tc_probe_save"]').on('click', () => {
        this.onboarding.goToNameStep();
      });

      this.silentUpdateProbeType("K");

    } else {

      this.branding = "default";

      if(!this.current_probe_type) {
        this.disableProbeSensor();
      }
    }

    this.GetReadings();

  }

  bindActions = () => {

    this.$probeStatus = $(this.onboarding.container).find('.tc-probe-status');
    this.$noProbeButton = $(this.onboarding.container).find('.button[data-for="tc_no_probe"]');
    this.$saveButton = $(this.onboarding.container).find('.button[data-for="tc_probe_save"]');
    this.$TcTypeSelect = $(this.onboarding.container).find('select[name="tc_type"]');
    this.imageSelects = Array.from(this.onboarding.container.querySelectorAll('.onboarding-tc-type-select'));

    this.imageSelects.forEach(imageSelect => {

      imageSelect.addEventListener('click', () => {
        this.updateProbeType(imageSelect.dataset.for);
      });

    })

    this.$noProbeButton.on('click', () => {
      this.$TcTypeSelect.val("none");
      this.updateProbeType("");
    });

    this.$saveButton.on('click', () => {
      this.onboarding.goToNameStep();
    });

    this.$TcTypeSelect.on('change', async () => {
      this.updateProbeType(this.$TcTypeSelect.val());
    });

  }

  setupSelective() {

    this.branding = 'selective';

    const $step = $(this.onboarding.container).find('.onboarding-step[data-for="connected_tc_setup"]');

    $step.html(this.selective_template);
    $(this.onboarding.container).find('.onboarding-heading__title').html('Connect the Pipe Sensor');

    this.$probeStatus = $step.find('.tc-probe-status');
    this.$liveReading = $step.find('.onboarding-tc-live-reading');
    this.$saveButton = $step.find('.button[data-for="tc_probe_save"]');
    this.imageSelects = Array.from($step.get(0).querySelectorAll('.onboarding-tc-type-select'));

    this.imageSelects.forEach(imageSelect => {
      imageSelect.addEventListener('click', () => {
        this.selectSelectiveProbe(imageSelect.dataset.for);
      });
    });

    this.$saveButton.on('click', () => {
      if(this.$saveButton.prop('disabled')) {
        return;
      }
      this.onboarding.goToNameStep();
    });

    // Testing-only: expose a control to flip the simulated probe between the
    // plugged-in and disconnected states so the template can be validated in
    // both without physical hardware.
    if(this.onboarding.is_simulation()) {
      const $toggle = $step.find('.onboarding-tc-test-toggle');
      $toggle.show();
      this.updateTestToggleLabel();
      $step.find('.button[data-for="tc_test_toggle_probe"]').on('click', () => {
        this.onboarding.simulate_probe_plugged_in = !this.onboarding.simulate_probe_plugged_in;
        this.updateTestToggleLabel();
        this.updateProbeStatus();
      });
    }

    this.updateProbeStatus();

  }

  selectSelectiveProbe(uiType) {

    if(uiType !== 'CLAMP' && uiType !== 'VELCRO_STRAP') {
      return;
    }

    if(!this.onboarding.sensor) {
      this.onboarding.sensor = {};
    }

    this.selective_ui_type = uiType;

    // the alerts review names the probe alert after the option picked here
    this.onboarding.probe_selection = uiType;

    this.imageSelects.forEach(select => {
      const isMatch = select.dataset.for === uiType;
      select.classList.toggle('is-selected', isMatch);
      select.querySelector('button').classList.toggle('hide', isMatch);
      select.querySelector('.onboarding-tc-type-select__selected').classList.toggle('hide', !isMatch);
    });

    // The clamp and velcro-strap are the same K-type clamp probe — only the
    // physical mounting differs — so both persist as a CLAMP probe.
    this.current_probe_type = 'K';
    this.probe_enabled = true;

    this.onboarding.sensor.probe_enabled = true;
    this.onboarding.sensor.probe_type = 'K';
    this.onboarding.sensor.probe_skin = 'CLAMP';

    this.onboarding.Temp_Stick_Request('POST', '/set/tc', {
      enabled: 1,
      type: 'K'
    }, true).catch(() => {});

    // Don't pollute the real request queue while simulating a test run.
    if(!this.onboarding.is_simulation()) {
      RequestQueueInstance.add(`/sensor/${this.onboarding.sensor.sid}/probe`, {
        TC_M: 1,
        TC_TYPE: 'K',
        TC_SKIN: 'CLAMP',
      });
    }

    this.$saveButton.prop('disabled', false);

    this.updateProbeStatus();

  }

  updateTestToggleLabel() {
    const label = this.onboarding.simulate_probe_plugged_in
      ? 'Testing: Probe Plugged In (click to unplug)'
      : 'Testing: Probe Unplugged (click to plug in)';

    $(this.onboarding.container)
      .find('.button[data-for="tc_test_toggle_probe"]')
      .text(label);
  }

  setLiveReadingState(state) {
    if(this.$liveReading && this.$liveReading.length) {
      this.$liveReading.attr('class', `onboarding-tc-live-reading is-${state}`);
    }
  }

  updateSelectiveProbeStatus() {

    if(!this.current_probe_type) {
      this.setLiveReadingState('idle');
      this.$probeStatus.html('Select your probe above to begin');
      return;
    }

    if(!this.last_reading || typeof this.last_reading.tcTempC === 'undefined') {
      this.setLiveReadingState('pending');
      this.$probeStatus.html('Probe Status: <b>Checking&hellip;</b>');
      return;
    }

    if(this.last_reading.tcTempC < -200 || this.last_reading.tcTempC === 'n') {
      this.setLiveReadingState('disconnected');
      this.$probeStatus.html(`
        Probe Status: <b>Not Detected</b><br />
        <div class="text--smaller">Plug the probe into your sensor &mdash; the live reading appears here once it's connected.</div>
      `);
    } else {
      this.setLiveReadingState('connected');
      this.$probeStatus.html(`
        Probe Status: <b>Connected</b>
        (${window.celsiusToUserTemp(this.last_reading.tcTempC, 1)}&deg;${window.getUserTempPref()})<br />
        <div class="text--smaller">Your probe is plugged in and reading correctly.</div>
      `);
    }

  }

  silentUpdateProbeType(type) {

    this.current_probe_type = type;

    this.onboarding.Temp_Stick_Request('POST', '/set/tc', {
      enabled: 1,
      type: type
    }, true).catch(() => {});

    this.probe_enabled = true;

    this.onboarding.sensor.probe_enabled = this.probe_enabled;
    this.onboarding.sensor.probe_type = this.current_probe_type;

  }

  updateProbeType(type) {

    if(!this.onboarding.sensor) {
      this.onboarding.sensor = {}
    }

    // Remember the option as picked (CLAMP, WINE_BOTTLE, a bare type...) before
    // it's folded into a thermocouple type below — the alerts review names the
    // probe alert after it. '-' is the "Other probe types..." placeholder.
    this.onboarding.probe_selection = (type && type !== 'none' && type !== '-') ? String(type) : '';

    this.imageSelects.forEach(select => {

      select.classList.remove('is-selected');

      if(select.dataset.for === type) {

        select.classList.add('is-selected');
        select.querySelector('button').classList.toggle('hide', true);
        select.querySelector('.onboarding-tc-type-select__selected').classList.toggle('hide', false);

      } else {
        select.querySelector('button').classList.toggle('hide', false);
        select.querySelector('.onboarding-tc-type-select__selected').classList.toggle('hide', true);
      }

    });

    this.$probeStatus.html("Probe Status: <b>Updating</b>");

    if(type === 'CLAMP') {
      this.onboarding.sensor.probe_skin = "CLAMP";
      type = "K";
    } else if(type === 'BUFFER_BOTTLE') {
      this.onboarding.sensor.probe_skin = "BUFFER_BOTTLE";
      type = "T";
    } else if(type === 'WINE_BOTTLE') {
      this.onboarding.sensor.probe_skin = "WINE_BOTTLE";
      type = "T";
    } else {
      this.onboarding.sensor.probe_skin = "DEFAULT";
    }

    if(type === '' || type === 'none' || !probeTypes.includes(type)) {

      this.$TcTypeSelect.val("none");
      this.current_probe_type = null;

      // disable probe
      this.onboarding.Temp_Stick_Request('POST', '/set/tc', {
        enabled: 0,
      }, true).catch(() => {});

      this.probe_enabled = false;

    } else {

      this.$TcTypeSelect.val(type);
      this.current_probe_type = type;

      this.onboarding.Temp_Stick_Request('POST', '/set/tc', {
        enabled: 1,
        type: type
      }, true).catch(() => {});

      this.probe_enabled = true;

    }

    this.onboarding.sensor.probe_enabled = this.probe_enabled;
    this.onboarding.sensor.probe_type = this.current_probe_type;

    RequestQueueInstance.add(`/sensor/${this.onboarding.sensor.sid}/probe`, {
      TC_M: this.probe_enabled ? 1 : 0,
      TC_TYPE: this.onboarding.sensor.probe_type ? this.onboarding.sensor.probe_type : "T",
      TC_SKIN: this.onboarding.sensor.probe_skin ? this.onboarding.sensor.probe_skin : "DEFAULT",
    });

  }

  updateClampStatus() {

    if(!this.last_reading) {
      return;
    }

    if(typeof this.last_reading.tcTempC != 'undefined') {
      if(this.last_reading.tcTempC < -200 || this.last_reading.tcTempC === 'n') {
        this.$probeStatus.html(`
          Status: <b>Disconnected</b><br />
          <div class="text--smaller">(Please plug the clamp into your Temp Stick)</div>
        `)
      } else {
        this.$probeStatus.html(`
          Status: <b>Connected</b> 
          (${window.celsiusToUserTemp(this.last_reading.tcTempC, 1)}&deg;${window.getUserTempPref()})
        `)
      }
    }

  }

  updateProbeStatus() {

    if(this.branding === 'AF') {

      this.updateClampStatus();
      return;

    }

    if(this.branding === 'selective') {

      this.updateSelectiveProbeStatus();
      return;

    }

    if(!this.probe_enabled) {
      this.$probeStatus.html(`
        Probe Status: <b>Turned Off</b><br />
        <div class="text--smaller">Connect your probe and select the type being used</div>
      `);
      return;
    }

    if(!this.last_reading) {
      return;
    }

    if(typeof this.last_reading.tcTempC != 'undefined') {
      if(this.last_reading.tcTempC < -200 || this.last_reading.tcTempC === 'n') {
        this.$probeStatus.html(`
          Probe Status: <b>Disconnected</b><br />
          <div class="text--smaller">(Select your probe type and insert into Temp Stick)</div>
        `)
      } else {
        this.$probeStatus.html(`
          Probe Status: <b>Connected</b> 
          (${window.celsiusToUserTemp(this.last_reading.tcTempC, 1)}&deg;${window.getUserTempPref()})<br />
          <div class="text--smaller">(For accuracy, choose the right probe type)</div>
        `)
      }
    }

  }

  disableProbeSensor() {

    this.onboarding.Temp_Stick_Request('POST', '/set/tc', {
      enabled: 0
    }, true);

    this.probe_enabled = false;
    this.onboarding.sensor.probe_enabled = this.probe_enabled;

  }

  enableProbeSensor() {

    this.onboarding.Temp_Stick_Request('POST', '/set/tc', {
      enabled: 1
    }, true);

    this.probe_enabled = true;
    this.onboarding.sensor.probe_enabled = this.probe_enabled;

  }

  async GetReadings() {

    if(this.onboarding.current_step === this.id) {

      try {

        const readings = await this.onboarding.Temp_Stick_Request('GET', '/get/readings');
        this.last_reading = readings;

        console.log({readings});

        setTimeout(this.GetReadings.bind(this), 1000);

      } catch (e) {
        setTimeout(this.GetReadings.bind(this), 1000);
      }

      this.updateProbeStatus();

    }

  }

}
